import React from 'react';
import store from '../../store/Store';

import actionTypes from '../../actionTypes/actionTypes';
import actions from '../../actions/Actions';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import { Redirect } from 'react-router-dom';

import Navigation from '../navigation/Navigation'
import PageSelection from '../pageSelection/PageSelection'
import EditorContextMenu from '../editorContextMenu/EditorContextMenu'
import EditorInformation from '../editorInformation/EditorInformation'

import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import Modal from '@material-ui/core/Modal';

import './editorModal.scss';

type editorModalState = {
	article: any;
  	navigation: any;
}

type editorModalProps = {
	article: any;
  	navigation: any;
}

class EditorModal extends React.Component<editorModalState, editorModalProps> {

  constructor(props) {
  	super(props)

  	this.state = {
  		article: props.article,
      	navigation: props.navigation
  	}
  }

  componentDidMount() {
  	store.subscribe(() => {
  		this.setState({
  			article: store.getState().article,
        	navigation: store.getState().navigation
  		})
  	})
  }

  componentWillUnmount() {
    store.subscribe(() => {
      this.setState({
        article: store.getState().article,
        navigation: store.getState().navigation
      })
    })
  }

  closeModal = () => {
    const { article } = this.state

    actions.articleActions.changeModal({
      modal: !article.modal
    })
  }

  saveTemplate = () => {
    console.log('Save Template')

    const { article } = this.state

    actions.articleActions.changeModal({
      modal: !article.modal
    })
  }

  countMedia = (article) => {
  	let media

  	article.pages.map((page, index, array) => {
  		page.index === article.info.currentPage && page.media.map((item, index, array) => {
  			media += 1
  		})
  	})

  	return media  	
  }

	render() {
		const { 
			article,
      		navigation
		} = this.state

		return (
			<div
				className="EditorModal"
			>
				<Modal
					open={ article.modal }
					onClose={ this.closeModal.bind(this) }
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
				>
					<div 
						style={{
							position: 'absolute',
							width: '400px',
							top: '50%',
							left: '50%',
							transform: 'translate(-50%, -50%)',
							backgroundColor: 'rgba(0, 0, 0, 255)',
							color: 'rgba(255, 255, 255, 255)',
							border: '1px solid black'
						}}
					>
						<h2
							style={{
								padding: '0 auto',
								width: '100%',
								textAlign: 'center'
							}}
						>
							Save Template
						</h2>

						<p
							style={{
								padding: '0 0 0 15px',
								width: '100%'
							}}
						>
							Rows: { article.rows }<br />
							Columns: { article.columns }<br />
							Types<br />
							Media: { this.countMedia.bind(this, article) }<br />
							ID:&nbsp;

							<input
								placeholder={ "e.g. 12 or 32; current is " /* + currentId */ }
							/>

							<br />
						</p>

						<div
							style={{
								float: 'left',
								padding: '15px 0 15px 15px'
							}}
						>
							<Button
								style={{
									color: 'black',
									backgroundColor: 'white'
								}}
								onClick={ this.closeModal.bind(this) }
							>
								Cancel
							</Button>
						</div>

						<div
							style={{
								float: 'right',
								padding: '15px 15px 15px 0'
							}}
						>
							<Button
								style={{
									color: 'black',
									backgroundColor: 'white'
								}}
								onClick={ this.saveTemplate.bind(this) }
							>
								Save
							</Button>
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}

export default EditorModal;